import { ApolloError } from '@apollo/client';
import { CloseRodRequestByStencilIdError } from '@bechtel/types';

export interface CloseRodRequestByStencilIdErrorProps {
  errors: CloseRodRequestByStencilIdError[] | ApolloError;
  close: () => void;
}
